import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import DashboardLayout from "./DashboardLayout";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ProductsPage from "../pages/ProductsPage";
import ProductDetailPage from "../pages/ProductDetailPage";
import ProductEditPage from "../pages/ProductEditPage";
import UsersPage from "../pages/UsersPage";
import ZytamaUsersPage from "../pages/ZytamaUsersPage";
import ZytamaUserDetailPage from "../pages/ZytamaUserDetailPage";
import BlogManagePage from "../pages/BlogManagePage";
import BlogDetailPage from "../pages/BlogDetailPage";

// Route guard: only accessible when NOT logged in
function PublicRoute() {
  const { user } = useAuth();
  if (user) {
    if (user.role === "reviewer") return <Navigate to="/products" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

function DefaultRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "reviewer") return <Navigate to="/products" replace />;
  return <Navigate to="/dashboard" replace />;
}

function DashboardGuard() {
  const { user } = useAuth();
  if (user?.role === "reviewer") return <Navigate to="/products" replace />;
  return <DashboardPage />;
}

// Route guard: only accessible when logged in
function PrivateRoute() {
  const { user } = useAuth();
  return !user ? <Navigate to="/login" replace /> : <Outlet />;
}

export const router = createBrowserRouter([
  {
    // Public routes: Login — NO sidebar/header here.
    element: <PublicRoute />,
    children: [
      { path: "/login", element: <LoginPage /> },
    ],
  },
  {
    // Private routes: Dashboard shell with sidebar/header
    element: <PrivateRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard", element: <DashboardGuard /> },
          { path: "/products", element: <ProductsPage /> },
          { path: "/products/:id", element: <ProductDetailPage /> },
          { path: "/products/:id/edit", element: <ProductEditPage /> },
          { path: "/users", element: <UsersPage /> },
          { path: "/zytama-users", element: <ZytamaUsersPage /> },
          { path: "/zytama-users/:id", element: <ZytamaUserDetailPage /> },
          { path: "/blogmanage", element: <BlogManagePage /> },
          { path: "/blogmanage/:id", element: <BlogDetailPage /> },
        ],
      },
    ],
  },
  { path: "/", element: <DefaultRoute /> },
  { path: "*", element: <DefaultRoute /> },
]);
